import { Box } from '@primer/react';
import { ImpactLensType } from '@upright/common/impact-lenses/types';
import { ImpactCategoryId } from '@upright/common/model/input/impacts/impact-categories';
import { FinalImpactScoreType } from '@upright/common/model/output/scores/types';
import { useCarouselContext } from '@upright/ui/common/upright/core/impact-lens-profile/context';
import { NetImpactLensOptions } from '@upright/ui/common/upright/core/impact-lenses/net-impact/types';
import { plusIfPositive } from '@upright/ui/common/upright/model/output/scores/net-impact-chart/shared';
import { formatImpactScore } from '@upright/ui/common/upright/model/output/scores/net-impact-chart/value-formatter';
import { isNil } from 'lodash';

interface Props {
  impact: ImpactCategoryId;
}

export function ImpactTitleNetFigure(props: Props) {
  const { impact } = props;

  // little bit ugly casting here, may wish to rework later on
  const ctx = useCarouselContext<ImpactLensType.UPRIGHT_NET_IMPACT>();
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (ctx.lensType !== ImpactLensType.UPRIGHT_NET_IMPACT) {
    return <></>;
  }
  const options = ctx.options as NetImpactLensOptions;
  const selection = ctx.selectionState;

  const value = options.scoreReader.readScore(impact, undefined, undefined, undefined);
  if (isNil(value) || !selection.showAllNetFigures) {
    return <></>;
  }
  const formatted = formatImpactScore(value, options.formatters, options.scoreUnit);
  const roundedValue = options.scoreUnit === FinalImpactScoreType.DOLLARS_PER_YEAR ? value : parseFloat(formatted); // '$' sign in parseFloat results in NaN
  const color = getColor(roundedValue);

  return (
    <Box as="tspan" sx={{ fill: color }}>
      &nbsp;
      {plusIfPositive(value)}
      {formatted}
    </Box>
  );
}

const getColor = (value: number) => {
  if (value > 0) return 'impact.positive.text.dark';
  else if (value < 0) return 'impact.negative.text.dark';
  return 'text.muted';
};
